<script setup lang="ts">
import { cn } from '#shared/utils';
import {
  NavigationMenuContent as RadixContent,
  type NavigationMenuContentEmits,
  type NavigationMenuContentProps,
  useForwardPropsEmits,
} from 'radix-vue';
import { computed, type HTMLAttributes, inject } from 'vue';

const props = defineProps<NavigationMenuContentProps & { class?: HTMLAttributes['class'] }>();
const emits = defineEmits<NavigationMenuContentEmits>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;
  return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);

// ⬅ read from root (defaults to true: viewport mode)
const hasViewport = inject(
  'navMenuHasViewport',
  computed(() => true),
);
</script>

<template>
  <RadixContent
    v-bind="forwarded"
    :class="
      cn(
        hasViewport
          ? 'left-0 top-0 w-full md:absolute md:w-auto data-[motion^=from-]:animate-in data-[motion^=to-]:animate-out data-[motion^=from-]:fade-in data-[motion^=to-]:fade-out data-[motion=from-end]:slide-in-from-right-52 data-[motion=from-start]:slide-in-from-left-52 data-[motion=to-end]:slide-out-to-right-52 data-[motion=to-start]:slide-out-to-left-52'
          : 'md:absolute left-0 top-full data-[motion^=from-]:animate-in data-[motion^=to-]:animate-out data-[motion^=from-]:fade-in data-[motion^=to-]:fade-out',
        'max-h-[70vh] overflow-y-auto',
        props.class,
      )
    "
  >
    <slot />
  </RadixContent>
</template>
